import { Observable, of, EMPTY } from "rxjs"
import { switchMap, map, catchError } from "rxjs/operators"
import { ofType, StateObservable } from "redux-observable"
import { Router } from "../../../server/router"
import type { EpicDependencies } from "../../rxjs/configureEpics"
import {
    ACCOUNT_SELECT_CLICKED,
    LOG_OUT_CLICKED,
    LOG_OUT_FAILURE,
    LOG_OUT_SUCCESS,
    logOutFailure,
    logOutSuccess,
} from "./actions"
import { getAccounts, getHttpHeaders, getOrganizations } from "../../auth/selectors"
import { cookieNames, setCookie } from "../../../utils/cookies"
import { accountSelectRequested, organizationSelected } from "../../auth/actions"
import { deleteAllCookies } from "../../auth/cookies"
import { Action, StateObject } from "../../redux/types"

export const logoutRequested = (
    actions$: Observable<Action>,
    state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(LOG_OUT_CLICKED),
        switchMap(() =>
            deps.api.logout(getHttpHeaders(deps.getState())).pipe(
                map(() => logOutSuccess()),
                catchError(error => of(logOutFailure(error)))
            )
        )
    )

export const logoutSuccess = (actions$: Observable<Action>) =>
    actions$.pipe(
        ofType(LOG_OUT_SUCCESS, LOG_OUT_FAILURE),
        switchMap(() => {
            // TODO investigate
            if (Router && Router.router) {
                Router.push("/login")
                deleteAllCookies()
            }

            return EMPTY
        })
    )

export const accountClicked = (
    actions$: Observable<Action>,
    state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(ACCOUNT_SELECT_CLICKED),
        switchMap((action: Action) => {
            const actions: Action[] = []
            const accountData = getAccounts(deps.getState())?.find(a => a.id === action.payload.accountId)
            const organizations = getOrganizations(deps.getState()) ?? []

            setCookie(cookieNames.accountId, action.payload.accountId)

            // If user has access to the organization, we want to set it to cookies/headers
            if (accountData?.organizationId && organizations.some(o => o.id === accountData?.organizationId)) {
                actions.push(organizationSelected(accountData.organizationId))
                setCookie(cookieNames.organizationId, accountData.organizationId)
            }

            return [...actions, accountSelectRequested(action.payload.accountId)]
        })
    )
export default [logoutRequested, logoutSuccess, accountClicked]
